<script>
  import {
    VIcon
  } from 'vuetify/lib'
  export default {
    name: 'wh-icon',
    extends: VIcon
  };
</script>